import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'HT_PHASOR',
  version: 1,
  label: 'Hilbert Phasor',
  pane: 'sub',
  category: 'cycles',
  series: 'price',
  order: 50,
  inputs: [],
  outputs: [line('inphase', 'In-phase', COLOR.blue), line('quadrature', 'Quadrature', COLOR.orange)],
  talib: { functions: ['HT_PHASOR'], expr: 'HT_PHASOR(close)', outputs: { inphase: 'inphase', quadrature: 'quadrature' } },
  listed: true,
  tailSafe: true,
  // TA_HT_PHASOR_Lookback: 32 (see TA_MAMA_Lookback).
  lookback: () => 32,
}
export default def
